import React from 'react';
import TiledBanner, { ITiledBannerProps } from '@base/features/TiledBanner';
import SwiperBanner, { ISwiperBannerProps } from '@base/features/SwiperBanner';
import { IOldFeatureBanner } from 'mod/feature/interface';
import cn from 'classnames';

export type IFeaturesProps = {
    dataList: IOldFeatureBanner[];
    wrapClassName?: string;
    tiledBanner?: Omit<ITiledBannerProps, 'data'>;
    banner?: Omit<ISwiperBannerProps, 'data'>;
    width?: number;
    height?: number;
}

const FeaturesBanner: React.FC<IFeaturesProps> = (props) => {
    const {
        wrapClassName,
        dataList = [],
        tiledBanner,
        banner,
        width,
        height,
    } = props

    return (
        <div className={cn(wrapClassName)}>
            {dataList.map((data, index) => {
                if (typeof width === 'number') {
                    data.config.width = width;
                }
                if (typeof height === 'number') {
                    data.config.height = height;
                }
                if(index === 0) {
                    data.config.preload = true;
                }

                switch (data.type) {
                    case 'tiledBanner' :
                        return (
                            <TiledBanner
                                key={data.moduleId}
                                data={data}
                                {...tiledBanner}
                            />
                        );
                    case 'banner' :
                    case 'swiperBanner' :
                        return (
                            <SwiperBanner
                                key={data.moduleId}
                                data={data}
                                {...banner}
                            />
                        );
                    default:
                        return null
                }
            })}
        </div>
    )
};

export default FeaturesBanner